if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.filterGeneralImagesBySize(this.dataset.selectedSize);
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (!button) return;
          button.addEventListener('click', (event) => this.setActiveMedia(mediaToSwitch.dataset.target, false, event));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      getItemAlt(item) {
        return item?.dataset?.mediaAlt || item?.querySelector('img')?.getAttribute('alt') || '';
      }

      getSizeTagFromAlt(alt) {
        if (!alt) return '';
        const parts = String(alt).split('--');
        if (parts.length < 2) return '';
        return parts[parts.length - 1].trim().toLowerCase();
      }

      filterGeneralImagesBySize(sizeValue) {
        if (this.dataset.showAllMedia === 'true') return;
        if (this.dataset.showHideByAlt !== 'true') return;

        const sizeTag = String(sizeValue || this.dataset.selectedSize || '')
          .trim()
          .toLowerCase();
        if (!sizeTag || !this.elements.viewer) return;

        this.dataset.selectedSize = sizeValue || this.dataset.selectedSize;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((item) => {
          if (item.classList.contains('product__media-item--variant')) return;

          const taggedSize = this.getSizeTagFromAlt(this.getItemAlt(item));
          if (!taggedSize) {
            item.classList.remove('is-size-hidden');
            return;
          }

          item.classList.toggle('is-size-hidden', taggedSize !== sizeTag);
        });

        this.dispatchEvent(new CustomEvent('gallery:media-change'));

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
          if (thumb.classList.contains('thumbnail-list_item--variant')) return;

          const taggedSize = this.getSizeTagFromAlt(this.getItemAlt(thumb));
          if (!taggedSize) {
            thumb.classList.remove('is-size-hidden');
            return;
          }

          thumb.classList.toggle('is-size-hidden', taggedSize !== sizeTag);
        });
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, isSticky) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (activeMedia.parentElement) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            !isSticky && activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);
        this.dispatchEvent(new CustomEvent('gallery:media-change'));

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
        if (typeof this.elements.thumbnails.isSlideVisible === 'function') {
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        }

        this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
